import React from 'react'
import moment from 'moment'
import groupBy from 'lodash/groupBy'

import QAWorkOrderCardContainer from '../../containers/qa-work-orders/qa-work-order-card-container'
import { CollectionButton } from '../buttons'

import { Collection, Group } from '../../components/details/collection'

export default ({
  qaWorkOrders,
  location,
  children,
  hasNextPage,
  onLoadNextPage
}) => {
  const sortedWorkOrders = groupBy(qaWorkOrders, wo => wo.createdAt.format('YYYY-MM-DD'))
  const sortedKeys = Object.keys(sortedWorkOrders).sort()

  return (
    <div>
      <Collection constraints={{ width: '595px' }} actionType='add' actionLink={`${location.pathname}/create`}>
        {sortedKeys.map((group, i) => {
          return (
            <Group title={moment(group).format('MMMM Do, YYYY')} key={group}>
              {
                sortedWorkOrders[group].map((qaWorkOrder, i) => (
                  <QAWorkOrderCardContainer
                    qaWorkOrderId={qaWorkOrder.id}
                    key={qaWorkOrder.id}
                  />
                ))
              }
            </Group>
          )
        })}

        {hasNextPage &&
          <CollectionButton onClick={onLoadNextPage}>See more...</CollectionButton>}

      </Collection>
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/qa-work-orders/qa-work-orders.js